import { instance } from "libs/api";

import { AuditLogResponse } from "../../auditLog.types";
import { ApiRoutesAuditLog } from "../../constants";

export const requestGetAuditLogById = async (
  auditLogId: string
): Promise<AuditLogResponse> => {
  return await instance.get(`${ApiRoutesAuditLog.AuditLogs}/${auditLogId}`);
};
